const ConsentformAr = {
  pageTitle: "بحث حروق الأطفال",
  language: "العربية",
  organization: "BGU",
  formTitle: "نموذج الموافقة",

  parentSection: {
    greeting: "إلى الوالد/ة العزيز/ة،",
    paragraphs: [
      "الهدف من البحث الحالي هو التعمق في المعرفة بخصوص حروق الأطفال من عمر ثلاثة أشهر حتى 18 عامًا.",
      "نحن نقدر مشاركتك ونعتبرها مهمة للغاية.",
      "إن البحث هو مشروع مشترك بين جامعة بن غوريون في النقب والمركز الطبي هداسا.",
      "تشمل المشاركة الإجابة على سبعة أسئلة فقط، والتقاط صورة للحرق اختياري تمامًا ويستغرق حوالي خمس دقائق فقط.",
      "يمكنك تخطي أي سؤال.",
      "نحن لا نطلب أي معلومات شخصية، مثل اسمك أو عنوانك.",
      "تفاصيلك أو تفاصيل ابنك/ابنتك لن تظهر في أي منشورات أو مقالات علمية متعلقة بالبحث.",
      "المشاركة في البحث لا تعرضك أنت أو ابنك/ابنتك لأي خطر ولا تمنحك أي فائدة محتملة.",
      "في حال كانت لديك أسئلة بخصوص هذا البحث، يرجى التواصل معنا من خلال التفاصيل الموجودة أدناه.",
      "كُتب الاستبيان بصيغة المذكر لراحة القراءة ولكنه موجه لجميع الأجناس.",
      "نتمنى لابنك/ابنتك الشفاء التام! وشكرًا لك على تخصيص الوقت للمشاركة في هذا البحث."
    ],
    closing: "مع الاحترام،",
    team: "طاقم البحث",
    contactText: "الرجاء التواصل من خلال البريد الإلكتروني:",
    email: "taliamst@bgu.ac.il",
    phoneText: "أو في رقم تلفون",
    phone: "0545655164"
  },

  doctorSection: {
    title: "طبيب",
    declaration: [
      "بتوقيعي، أقر بأنني شرحت شفهيًا للوالد/ة القاصر/ة عن البحث وفقًا لما هو مكتوب في هذه الاستمارة.",
      "أعتقد أن الوالد/ة فهم/ت الموضوع، وكان لديه/ا وقت كافٍ لقراءة الاستمارة وأبدى/ت موافقته/ا على المشاركة في البحث.",
      "بالإضافة إلى ذلك، أقر بأنني شرحت للقاصر/ة بحضور والديه/ا عن البحث وأعرب/ت عن رغبته/ا في المشاركة في الاستطلاع."
    ],
    doctorNameLabel: "اسم الطبيب",
    doctorName: "د. إسرائيلي إسرائيلي",
    HospitalName:"اسم المستشفى:",
    clickToSign: "انقر للتوقيع",
    signature: "إمضاء",
    licenseNumberLabel: "رقم الرخصة",
    licenseNumber: "1685723",
    dateLabel: "تاريخ",
    date: "02/03/2024"
  },
signature: {
  clickToSign: "اضغط هنا للتوقيع",
  title: "التوقيع",
  instruction: "يرجى التوقيع داخل المربع المحدد",
  save: "حفظ",
  clear: "مسح التوقيع",
  previewAlt: "معاينة التوقيع"
},
  parentApprovalSection: {
    fullNameLabel: "الاسم الكامل",
    parentNameLabel: "اسم الوالدين",
    serialNumberLabel: "رقم تسلسلي",
    serialNumber: "12-986-45",
    approvalLabel: "مصادقة"
  },
  error: {
    required:"*هذا الحقل مطلوب",
    require2:"*يرجى إدخال الاسم الأول واسم العائلة",
    doctorName: "يرجى إدخال اسم الطبيب",
    licenseNumber: "يرجى إدخال رقم الرخصة",
    HospitalName: "يرجى إدخال اسم المستشفى"
  }
};

export default ConsentformAr;
